import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import React from 'react';
import Profile from '@/creditflowresearch/ui/components/profile';
import { ProfileTypes } from '@/creditflowresearch/application/actions/profile/constants';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import getServerSideResearchData from '@/creditflowresearch/application/Research/serverSide/getServerSideResearchData';
import { DOCUMENT_GROUP_NAMES } from '@/creditflowresearch/domain/DocumentGroup';
import getServerSideTopCompany from '@/creditflowresearch/application/TopCompanies/serverSide/getServerSideTopCompany';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import getServerSideProfileBreadcrumbs
  from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideProfileBreadcrumbs';
import { getServerSideBondsTileData,
} from '@/creditflowresearch/application/Bonds/serverSide/getServerSideBondsTileData';
import {
  getServerSideTraceTileData,
} from '@/creditflowresearch/application/Trace/serverSide/getServerSideTraceTileData';
import getServerSideChartData from '@/creditflowresearch/application/MarketChart/serverSide/getServerSideChartData';
import * as FILTER_TYPES from '@/creditflowresearch/application/PageFiltersState/constants';
import ParentPageContextProvider from '@/creditflowresearch/application/ParentPageContext';
import getServerSideArticlesTile
  from '@/creditflowresearch/application/ArticlesAndStats/Articles/ArticlesTile/serverSide/getServerSideArticlesTile';
import { getProducts } from '@/creditflowresearch/application/Deal/helpers';
import getServerSideDealsByProduct from '@/creditflowresearch/application/Deal/helpers/utils/getServerSideDealsByProduct';
import getServerSideRoadshows from '@/creditflowresearch/application/Roadshows/serverSide/getServerSideRoadshows';
import { featureToggleServerSide } from '@framework/ui/Organisms/FeatureToggle/Components';
import { HIDE_TOP_COMPANIES } from '@creditflowresearch/config/featureToggle';
import { initialTopCompanies } from '@/creditflowresearch/application/TopCompanies/constants';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const { availableProductIds, activeProductId } = getProducts(context);

  const [
    deals,
    topParents,
    researchData,
    chartData,
    bondTileData,
    traceTileData,
    articlesTilesData,
    roadshowsTileData,
  ] = await Promise.all([
    getServerSideDealsByProduct(context, {
      profileType: ProfileTypes.INDUSTRY,
    }),
    featureToggleServerSide(context, {
      featureName: HIDE_TOP_COMPANIES,
      featureCallback: getServerSideTopCompany,
      featureCallbackParams: { profileType: ProfileTypes.INDUSTRY },
      defaultCallback: async () => initialTopCompanies,
    }),
    getServerSideResearchData(context, { isTile: true, groupName: DOCUMENT_GROUP_NAMES.REPORTS }),
    getServerSideChartData(context, { filterType: FILTER_TYPES.INDUSTRY }),
    getServerSideBondsTileData(context),
    getServerSideTraceTileData(context),
    getServerSideArticlesTile(context, { deal: null }),
    getServerSideRoadshows(context, { isTile: true }),
  ]);

  const breadcrumbs = getServerSideProfileBreadcrumbs(context, ProfileTypes.INDUSTRY);

  return ({
    props: {
      breadcrumbs,
      topParents,
      deals,
      researchData,
      chartData,
      bondTileData,
      traceTileData,
      articlesTilesData,
      availableProductIds,
      activeProductId,
      roadshowsTileData,
    },
  });
}, {
  dictionaries: ['documentTypeGroups', 'countries', 'sizeDescriptions', 'ratingAgencies'],
  needsLegacyDictionaries: false,
});

const BondIssuanceOverview = (props) => (
  <PageFiltersContextProvider profileType={ ProfileTypes.INDUSTRY }>
    <ParentPageContextProvider parentProps={ {
      topParents: props?.topParents,
      deals: props?.deals,
      research: props?.researchData,
      chartData: props?.chartData,
      traceTileData: props?.traceTileData,
      bondTileData: props?.bondTileData,
      articlesTilesData: props?.articlesTilesData,
      availableProductIds: props?.availableProductIds,
      activeProductId: props?.activeProductId,
      roadshowsTileData: props?.roadshowsTileData,
    } }
    >
      <PageContentLayout>
        <Profile profileType={ ProfileTypes.INDUSTRY } />
      </PageContentLayout>
    </ParentPageContextProvider>
  </PageFiltersContextProvider>
);

export default BondIssuanceOverview;
